import { inputTextAreaProps } from '@/assets/props/defaultProps';

export const opticalScienceApplicationMotive = {
  title: '1. 안경광학과 지원 동기',
  inputs: [
    {
      inputName: 'motive',
      colProps: {
        cols: 12, sm: 12, md: 12, xl: 12,
      },
      inputInfos: {
        inputComponent: 'v-textarea',
        inputProps: {
          ...inputTextAreaProps,
          label: '작성란 (1000자 이내)',
          required: true,
          appendIcon: '$complete',
          rules: [
            v => !!v || '지원 동기를 입력해 주세요.',
            v => v && v.length <= 1000 || '지원 동기는 1000자 이내로 입력해 주세요.',
          ],
        },
      },
    },
  ],
};